import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBannerSuccess = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M5 14.4142L0 9.41421L1.41421 8L5 11.5858L14.5858 2L16 3.41421L5 14.4142Z",
		fill: "#1E762E"
	})
});
export default SvgBannerSuccess;
